import { Array, Boolean, Null, Number, Optional, Record, Static, String } from 'runtypes';

import { IdoButtonRunType } from 'src/models/ido';
import { SpoingButtonRunType } from 'src/models/spoing';
import { TaskButtonRunType } from 'src/models/task';

export const CalendarModelRepetitionRunType = Record({
	durationEnd: String,
	firstDate: String,
	groupId: Number,
	hasAnEnd: String,
	id: Number,
	monthDate: String.Or(Null),
	nTimes: Number,
	repetitionType: String,
	tact: Number.Or(String),
	weekdays: String,
});

export type CalendarModelRepetition = Static<typeof CalendarModelRepetitionRunType>;

export const ParticipantsOfAppointmentRunType = Record({
	Displayname: String,
	Fullname: String,
	UserAvatar: Optional(String),
	accept: String,
	active: String,
	alert: String,
	confirmed: String,
	hidden: Null,
	memberId: Number,
	userId: Number,
	write: String,
});

export type ParticipantsOfAppointment = Static<typeof ParticipantsOfAppointmentRunType>;

export const CalendarModelColorsRunType = Record({
	appointmentTimeType: Optional(String),
	appointmentTypeAccess: String,
	appointmentTypeAlert: Optional(Number),
	appointmentTypeColor: String,
	appointmentTypeDescription: Optional(String),
	appointmentTypeId: Number,
	appointmentTypeTitle: String,
	forbiddenRepetition: Boolean,
});

export type CalendarModelColors = Static<typeof CalendarModelColorsRunType>;

export const FullUserlistWithParticipantsOfAppointmentRunType = Record({
	Displayname: String,
	Fullname: String,
	UserAvatar: String,
	accept: String,
	active: String,
	alert: String,
	collision: Null,
	confirmed: Null.Or(String),
	hidden: String,
	memberId: String,
	userId: String,
	write: String,
});

export type FullUserlistWithParticipantsOfAppointment = Static<typeof FullUserlistWithParticipantsOfAppointmentRunType>;

export const AppointmentVirtualGroupsRunType = Record({
	groupName: String,
	id: String,
	users: Array(String),
});

export type AppointmentVirtualGroups = Static<typeof AppointmentVirtualGroupsRunType>;

export const AppointmentRunType = Record({
	access: String,
	aggregateId: String,
	alert: Number,
	allDay: String.Or(Boolean),
	appointmentColor: String.Or(Null),
	appointmentId: Number,
	appointmentType: Number.Or(String),
	calendarId: Number,
	calendarModelColors: Array(CalendarModelColorsRunType),
	calendarModelRepetition: CalendarModelRepetitionRunType,
	checkCollision: Boolean,
	color: String.Or(Null),
	confirmedByUser: Null,
	creator: String,
	creatorAbbreviation: Null,
	creatorId: Number,
	description: String,
	endDate: String,
	fullUserlistWithParticipantsOfAppointment: Array(FullUserlistWithParticipantsOfAppointmentRunType),
	idoButton: Optional(IdoButtonRunType),
	linkedIdoCounter: Number,
	location: String.Or(Null),
	minuteInterval: String,
	needsConfirmation: String,
	participantsOfAppointment: Array(ParticipantsOfAppointmentRunType),
	participation: String,
	repetitionGroupId: Number,
	spoingButton: Optional(SpoingButtonRunType),
	startDate: String,
	taskButton: Optional(TaskButtonRunType),
	timeMode: String,
	title: String,
	virtualGroups: Array(AppointmentVirtualGroupsRunType),
	writepermission: String,
});

export type Appointment = Static<typeof AppointmentRunType>;

export const AppointmentTypeRunType = Record({
	fullUserlistWithParticipants: Array(FullUserlistWithParticipantsOfAppointmentRunType),
	idoButton: IdoButtonRunType,
	updatedAppointmentTypeId: Number,
});

export type AppointmentType = Static<typeof AppointmentTypeRunType>;

const IdoLinking = Record({
	idoId: Number,
	idoInstanceId: Number,
	instanceTitle: Optional(String),
});

export const AppointmentTypeWithColorRunType = Record({
	appointmentTimeType: String,
	appointmentTypeAccess: String,
	appointmentTypeAlert: Number,
	appointmentTypeColor: String,
	appointmentTypeDescription: String,
	appointmentTypeId: Number,
	appointmentTypeTitle: String,
	forbiddenRepetition: Boolean,
	idoLinkings: Array(IdoLinking),
});

export type AppointmentTypeWithColor = Static<typeof AppointmentTypeWithColorRunType>;

export const CalendarExportResultRunType = Record({
	icalString: String,
});

export type CalendarExportResult = Static<typeof CalendarExportResultRunType>;

export const AppointmentTimerRunType = Record({
	aggregateId: String,
	appointmentTypeId: Number,
	endTime: String.Or(Null),
	ifsAppointmentId: Number,
	startTime: String,
	title: String,
	userId: Number,
});

export const TimerFavoriteRunType = Record({
	appointmentRoundingMinutes: Number,
	appointmentTypeId: Number,
	id: Number,
	order: Number,
	title: String.Or(Null),
});
